<script setup lang="ts">
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

import { getSettingsNavigationItems } from '@/lib/settings'

defineProps<{
  title: string
  description: string
}>()

const page = usePage()
const navigationItems = computed(() => getSettingsNavigationItems(page.url))
</script>

<template>
  <UDashboardPanel id="settings">
    <template #header>
      <UDashboardNavbar :title="title" :ui="{ right: 'gap-3' }">
        <template #leading>
          <UDashboardSidebarCollapse />
        </template>
      </UDashboardNavbar>

      <UDashboardToolbar>
        <template #left>
          <UNavigationMenu
            :items="navigationItems"
            class="-ms-2 min-w-0"
            :ui="{
              list: 'gap-1 overflow-x-auto',
              link: 'whitespace-nowrap',
            }"
          />
        </template>

        <template #right>
          <p class="text-muted hidden text-sm xl:block">
            {{ description }}
          </p>
        </template>
      </UDashboardToolbar>
    </template>

    <template #body>
      <div class="mx-auto flex w-full max-w-5xl flex-col gap-6">
        <slot />
      </div>
    </template>
  </UDashboardPanel>
</template>
